module.exports = __webpack_public_path__ + "static/media/close-white.417d80e7.svg";